module.exports = __webpack_public_path__ + "static/btnTip3.d7d18b91.png";